import React from "react";
import styled from "styled-components";
import { palette } from "../../../../assets/styles/Palette";
import { Button } from "../../../../assets/styles/ButtonStyle";
import { Body1, Body3, InputText } from "../../../../assets/styles/Typography";

// 미리보기 배경 이미지 import
import PreviewRed from "../../../../assets/images/Preview_Red.png";
import PreviewBlue from "../../../../assets/images/Preview_blue.png";
import PreviewBlack from "../../../../assets/images/Preview_Black.png";

const MoleculeTemplateCard = ({ 
  template,
  onPreview,
  onSelect,
  isSelected,
  title,
  location,
  selectedDesignConcepts = []
}) => {
  
  // 현재 템플릿의 카테고리에 따라 배경 이미지 결정
  const getBackgroundImage = () => {
    switch(template?.category) {
      case "기본 심플형":
        return PreviewRed;
      case "어두운 기본형":
        return PreviewBlack;
      case "소프트 블루형":
        return PreviewBlue;
      default:
        return PreviewRed;
    }
  };

  return (
    <TemplateCard>
      <TemplateImageContainer backgroundImage={getBackgroundImage()}>
        <PreviewOverlay>
          <PreviewButton
            onClick={() => onPreview && onPreview(template)}
          >
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.4982 5.97656C17.0176 5.97656 21.0841 8.45875 22.3546 11.834C22.479 12.1648 22.497 12.5362 22.3849 12.8906C21.61 15.3386 18.5559 18.5762 12.4982 18.5762C6.4168 18.576 3.42075 15.0231 2.63488 12.918C2.50683 12.5749 2.50547 12.2079 2.61144 11.875C3.16333 10.1415 4.5396 8.66789 6.28332 7.6377C8.03511 6.60278 10.2185 5.97664 12.4982 5.97656ZM12.4982 7.57617C10.5026 7.57625 8.60015 8.1265 7.09679 9.01465C5.58531 9.90763 4.53672 11.1045 4.13683 12.3604C4.13651 12.3614 4.13602 12.3626 4.13585 12.3633C4.70504 13.8806 7.12813 16.9764 12.4982 16.9766C17.9325 16.9766 20.3163 14.1228 20.8595 12.4092L20.8566 12.3975C19.8773 9.79587 16.5276 7.57617 12.4982 7.57617ZM12.4991 8.47656C14.5978 8.47656 16.2988 10.1778 16.2989 12.2764C16.2989 14.375 14.5978 16.0762 12.4991 16.0762C10.4005 16.0761 8.69933 14.375 8.69933 12.2764C8.69944 10.1778 10.4006 8.47667 12.4991 8.47656ZM12.4991 10.0762C11.2843 10.0763 10.299 11.0615 10.2989 12.2764C10.2989 13.4913 11.2842 14.4765 12.4991 14.4766C13.7142 14.4766 14.6993 13.4914 14.6993 12.2764C14.6992 11.0614 13.7141 10.0762 12.4991 10.0762Z" fill="white"/>
            </svg>
            <span style={{
              fontSize: '16px',
              fontWeight: '400',
              lineHeight: '1.2',
              color: 'white',
              letterSpacing: '-0.36px',
              marginLeft: '8px'
            }}>
              미리보기
            </span>
          </PreviewButton>
        </PreviewOverlay>
      </TemplateImageContainer>
      
      <TemplateContent>
        <TemplateHeader>
          <TemplateCategory>
            <Body3 color="primary" style={{fontSize: "12px"}}>{template.category}</Body3>
          </TemplateCategory>
        </TemplateHeader>
        
        <TemplateTitle>
          <Body1 color="gray800" style={{fontSize: "24px"}}>{title}</Body1>
        </TemplateTitle>
        
        <TemplateDescription>
          <Body3 color="gray600">{template.description}</Body3>
          {/* <LocationText style={{marginTop: "16px"}}>
            자료 이용 장소 : <LocationValue>{location}</LocationValue>
          </LocationText> */}
        </TemplateDescription>
      </TemplateContent>

      <TemplateActions>
        <CustomUseButton 
          $isSelected={isSelected}
          onClick={() => onSelect && onSelect(template)}
        >
          {isSelected ? '선택됨' : '사용하기'}
        </CustomUseButton>
      </TemplateActions>
    </TemplateCard>
  );
};

export default MoleculeTemplateCard;

const TemplateCard = styled.div`
  display: flex;
  flex-direction: row;
  border: 1px solid ${palette.outlineGray};
  border-radius: 12px;
  overflow: hidden;
  background: white;
  transition: all 0.2s ease;
  width: 100%;
  box-sizing: border-box;
  
  &:hover {
    border-color: ${palette.primary};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

const TemplateImageContainer = styled.div`
  width: 220px;
  height: 212px;
  flex-shrink: 0;
  overflow: hidden;
  background-color: ${palette.gray100};
  background-image: url(${props => props.backgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  
  &:hover {
    .preview-overlay {
      opacity: 1;
    }
  }
`;

const TemplateContent = styled.div`
  flex: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 28px;
  margin-left: 16px;
`;

const TemplateHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4px;
`;

const TemplateCategory = styled.div`
  color: ${palette.primary};
  font-weight: 500;
  background-color: ${palette.primaryLightest};
  padding: 3px 8px;
  border-radius: 4px;
  margin-top: -10px;
`;

const TemplateTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${palette.gray800};
  margin-bottom: -4px;
  text-align: left;
  margin-top: 4px;
`;

const TemplateDescription = styled.div`
  font-size: 14px;
  color: ${palette.gray600};
  line-height: 1.4;
  flex: 1;
  text-align: left;
`;

const TemplateActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  flex-shrink: 0;
`;

const CustomUseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Pretendard', 'Poppins';
  font-size: 16px !important;
  font-weight: 500;
  line-height: 1.5;
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  min-width: 100px;
  min-height: 52px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  ${props => props.$isSelected ? `
    color: ${palette.white};
    background: ${palette.primary};
    
    &:hover {
      background: #0B45B1;
    }
  ` : `
    color: ${palette.primary};
    background: ${palette.primaryLightest};
    
    &:hover {
      background: rgba(34, 111, 255, 0.2);
    }
  `}
  
  &:disabled {
    color: ${palette.gray500};
    background: #ECEFF3;
    cursor: not-allowed;
  }
`;

const LocationText = styled(Body3)`
  color: ${palette.gray800};
`;

const LocationValue = styled.span`
  color: ${palette.primary};
`;

const PreviewOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  transition: opacity 0.3s ease;
`;

const PreviewButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid white;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
  backdrop-filter: blur(4px);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-1px);
  }
`; 